"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationType = exports.PaymentStatus = exports.BookingStatus = void 0;
var BookingStatus;
(function (BookingStatus) {
    BookingStatus["PENDING_PAYMENT"] = "pending_payment";
    BookingStatus["CONFIRMED"] = "confirmed";
    BookingStatus["IN_PROGRESS"] = "in_progress";
    BookingStatus["COMPLETED"] = "completed";
    BookingStatus["CANCELLED"] = "cancelled";
    BookingStatus["RESCHEDULED"] = "rescheduled";
})(BookingStatus || (exports.BookingStatus = BookingStatus = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["PARTIAL"] = "partial";
    PaymentStatus["PAID"] = "paid";
    PaymentStatus["REFUNDED"] = "refunded";
    PaymentStatus["FAILED"] = "failed";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var AccommodationType;
(function (AccommodationType) {
    AccommodationType["HOTEL"] = "hotel";
    AccommodationType["APARTMENT"] = "apartment";
    AccommodationType["HOSTEL"] = "hostel";
    AccommodationType["CLINIC_ACCOMMODATION"] = "clinic_accommodation";
})(AccommodationType || (exports.AccommodationType = AccommodationType = {}));
//# sourceMappingURL=booking.types.js.map